import React, { useEffect, useState } from "react";
import { db } from "../../../../../../firebase";
import {
  collection,
  doc,
  getDoc,
  getDocs,
} from "firebase/firestore";

export default function SubscriptionPlansSection({
  companyId,
  selectedPlan,
  setSelectedPlan,
}) {
  const [plans, setPlans] = useState([]);
  const [currentPlanId, setCurrentPlanId] = useState(null);
  const [currentPlanName, setCurrentPlanName] = useState("FREE");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        /* -----------------------------
           MEVCUT ABONELİK
        ------------------------------ */
        const subRef = doc(
          db,
          "companies",
          companyId,
          "subscription",
          "subscription_plan"
        );
        const subSnap = await getDoc(subRef);

        const activePlanId = subSnap.exists()
          ? subSnap.data().planId
          : null;

        if (activePlanId) {
          setCurrentPlanId(activePlanId);
        }

        /* -----------------------------
           PLAN LİSTESİ
        ------------------------------ */
        const plansSnap = await getDocs(collection(db, "subscriptions"));
        const list = [];

        plansSnap.forEach((docSnap) => {
          list.push({ id: docSnap.id, ...docSnap.data() });
        });

        setPlans(list);

        /* -----------------------------
           AKTİF PLAN ADI
        ------------------------------ */
        const activePlan = list.find(
          (p) => p.id === activePlanId
        );

        if (activePlan) {
          setCurrentPlanName(activePlan.name);
        } else {
          setCurrentPlanName("FREE");
        }
      } catch (err) {
        console.error("Planlar yüklenemedi:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, [companyId]);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div style={styles.spinner}></div>
        <p style={styles.loadingText}>Planlar yükleniyor...</p>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Abonelik Planları</h2>
        <p style={styles.subtitle}>
          İşinize uygun planı seçerek aboneliğinizi yükseltin
        </p>
      </div>

      <div style={styles.currentPlanSection}>
        <span style={styles.currentPlanLabel}>Mevcut Aboneliğiniz:</span>
        <span style={styles.currentPlanName}>{currentPlanName}</span>
      </div>

      <div style={styles.planGrid}>
        {plans.map((plan) => {
          const isFree = plan.id === "free";
          const isSelected = selectedPlan?.id === plan.id;
          const isCurrentPlan = plan.id === currentPlanId;
          const isPopular = plan.id === "premium";

          return (
            <div
              key={plan.id}
              style={{
                ...styles.card,
                ...(isSelected && styles.cardSelected),
                ...(isCurrentPlan && styles.cardCurrent),
                ...(isPopular && styles.cardPopular),
              }}
              onClick={() => {
                if (!isFree && !isCurrentPlan) {
                  setSelectedPlan(plan);
                }
              }}
            >
              {isCurrentPlan && (
                <div style={styles.currentBadge}>Aktif Plan</div>
              )}

              {isPopular && (
                <div style={styles.popularBadge}>Popüler</div>
              )}

              <div style={styles.cardHeader}>
                <h3 style={styles.planName}>{plan.name}</h3>
              </div>

              <div style={styles.priceSection}>
                <div style={styles.price}>
                  {plan.price === 0 ? "Ücretsiz" : `₺${plan.price}`}
                </div>
                {plan.price > 0 && (
                  <div style={styles.pricePeriod}>/aylık</div>
                )}
              </div>

              <div style={styles.features}>
                <div style={styles.feature}>
                  <span style={styles.featureCheck}>✓</span>
                  <span style={styles.featureText}>
                    Proje Limiti:{" "}
                    <strong>
                      {plan.features.projectLimit === -1
                        ? "Sınırsız"
                        : plan.features.projectLimit}
                    </strong>
                  </span>
                </div>

                <div style={styles.feature}>
                  <span style={styles.featureCheck}>✓</span>
                  <span style={styles.featureText}>
                    Analitik:{" "}
                    <strong>
                      {plan.features.analytics ? "Var" : "Yok"}
                    </strong>
                  </span>
                </div>

                <div style={styles.feature}>
                  <span style={styles.featureCheck}>✓</span>
                  <span style={styles.featureText}>
                    Öne Çıkarma:{" "}
                    <strong>{plan.features.highlight}</strong>
                  </span>
                </div>
              </div>

              <button
                style={{
                  ...styles.selectBtn,
                  ...(isCurrentPlan
                    ? styles.selectBtnCurrent
                    : isSelected
                    ? styles.selectBtnSelected
                    : isFree
                    ? styles.selectBtnDisabled
                    : styles.selectBtnDefault),
                }}
                disabled={isFree || isCurrentPlan}
              >
                {isFree
                  ? "Mevcut Plan"
                  : isCurrentPlan
                  ? "Aktif Plan"
                  : isSelected
                  ? "Seçildi"
                  : "Planı Seç"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  container: {
    backgroundColor: "#fff",
    padding: "32px",
    borderRadius: "12px",
    marginBottom: "24px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
    border: "1px solid #e5e7eb",
  },
  loadingContainer: {
    backgroundColor: "#fff",
    padding: "60px 30px",
    borderRadius: "12px",
    marginBottom: "24px",
    textAlign: "center",
    border: "1px solid #e5e7eb",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "3px solid #f3f3f3",
    borderTop: "3px solid #3b82f6",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    margin: "0 auto 16px",
  },
  loadingText: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
  },
  header: {
    marginBottom: "24px",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#111827",
    margin: "0 0 4px 0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#6b7280",
    margin: 0,
  },
  currentPlanSection: {
    marginBottom: "28px",
    paddingBottom: "20px",
    borderBottom: "1px solid #f3f4f6",
  },
  currentPlanLabel: {
    fontSize: "14px",
    color: "#6b7280",
    marginRight: "8px",
  },
  currentPlanName: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#111827",
    backgroundColor: "#f3f4f6",
    padding: "4px 12px",
    borderRadius: "6px",
  },
  planGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "20px",
  },
  card: {
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    padding: "24px",
    transition: "all 0.2s ease",
    position: "relative",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  cardSelected: {
    borderColor: "#3b82f6",
    borderWidth: "2px",
    boxShadow: "0 4px 12px rgba(59, 130, 246, 0.08)",
  },
  cardCurrent: {
    borderColor: "#10b981",
  },
  cardPopular: {
    borderColor: "#8b5cf6",
  },
  currentBadge: {
    position: "absolute",
    top: "-10px",
    right: "16px",
    backgroundColor: "#10b981",
    color: "#fff",
    padding: "4px 12px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.5px",
  },
  popularBadge: {
    position: "absolute",
    top: "-10px",
    right: "16px",
    backgroundColor: "#8b5cf6",
    color: "#fff",
    padding: "4px 12px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.5px",
  },
  cardHeader: {
    marginBottom: "20px",
  },
  planName: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#111827",
    margin: "0 0 8px 0",
  },
  priceSection: {
    display: "flex",
    alignItems: "baseline",
    gap: "4px",
    marginBottom: "24px",
  },
  price: {
    fontSize: "32px",
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1,
  },
  pricePeriod: {
    fontSize: "14px",
    color: "#6b7280",
    fontWeight: 400,
  },
  features: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    marginBottom: "24px",
    minHeight: "120px",
  },
  feature: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
  },
  featureCheck: {
    color: "#10b981",
    fontSize: "14px",
    fontWeight: "bold",
    flexShrink: 0,
    marginTop: "2px",
  },
  featureText: {
    fontSize: "14px",
    color: "#4b5563",
    lineHeight: 1.5,
  },
  selectBtn: {
    width: "100%",
    padding: "12px",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "all 0.2s ease",
    textAlign: "center",
  },
  selectBtnDefault: {
    backgroundColor: "#3b82f6",
    color: "#fff",
  },
  selectBtnSelected: {
    backgroundColor: "#10b981",
    color: "#fff",
  },
  selectBtnCurrent: {
    backgroundColor: "#f3f4f6",
    color: "#6b7280",
    cursor: "default",
  },
  selectBtnDisabled: {
    backgroundColor: "#f3f4f6",
    color: "#9ca3af",
    cursor: "not-allowed",
  },
};

// Spinner animasyonu için CSS
if (typeof document !== 'undefined') {
  const styleSheet = document.styleSheets[0];
  if (styleSheet) {
    styleSheet.insertRule(`
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `, styleSheet.cssRules.length);
  }
}